module.exports = __webpack_public_path__ + "img/team2.c3543d70.png";